import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Register from "./components/Register/Register";
import { ScrollToTop } from "react-router-scroll-to-top";
import Top from "./components/Top/Top";
import OnlineShop from "./components/OnlineShop/OnlineShop";
import Footer from "./components/Footer/Footer";
import CommercialTransactions from "./components/CommercialTransactions/CommercialTransactions";
import Features from "./components/Features/Features";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import Gallery from "./components/Gallery/Gallery";
import Faq from "./components/Faq/Faq";
import VisitRegistration from "./components/VisitRegistration/VisitRegistration";
import UsageFlow from "./components/UsageFlow/UsageFlow";
import MemberRegistration from "./components/MemberRegistration/MemberRegistration";
import RegistrationDataShow from "./components/MemberRegistration/RegistrationDataShow";
import Otp from "./components/MemberRegistration/Otp";
import ForgotID from "./components/ForgotID/ForgotID";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import CreateAlbum from "./components/Album/CreateAlbum";
import DesignBox from "./components/DesignBox/DesignBox";
import TypeA20 from "./components/EditScreen/TypeA20/TypeA20";
import WoodenPlateSquare from "./components/EditScreen/WoodenPlateSquare/WoodenPlateSquare";
import CartItem from "./components/Cart/CartItem";
import CartDetails from "./components/Cart/CartDetails";
import PurchaseHistoryMain from "./components/PurchaseHistory/PurchaseHistoryMain";
import PurchaseDetails from "./components/CheckHistory/PurchaseDetails";
import Inquiry from "./components/Inquiry/Inquiry";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import WoodenPlateRectangle from "./components/EditScreen/WoodenPlateRectangle/WoodenPlateRectangle";
import WoodenDesignPlate from "./components/EditScreen/WoodenDesignPlate/WoodenDesignPlate";
import MountSide3P1 from "./components/EditScreen/MountSide3P1/MountSide3P1";
import MountSide2C2 from "./components/EditScreen/MountSide2C2/MountSide2C2";
import MountSide2C1 from "./components/EditScreen/MountSide2C1/MountSide2C1";
import CalenderWall from "./components/EditScreen/CalenderWall/CalenderWall";
import KeyringRectangle from "./components/EditScreen/KeyringRectangle/KeyringRectangle";
import KeyringSquare from "./components/EditScreen/KeyringSquare/KeyringSquare";
import PrintL from "./components/EditScreen/PrintL/PrintL";
import Print2L from "./components/EditScreen/Print2L/Print2L";
import PrintQuarterSize from "./components/EditScreen/PrintQuarterSize/PrintQuarterSize";
import Postcard from "./components/EditScreen/Postcard/Postcard";
import NewYearCard from "./components/EditScreen/NewYearCard/NewYearCard";
import PassportPartPhoto from "./components/EditScreen/PassportPartPhoto/PassportPartPhoto";
import Login from "./components/Login/Login";
import RegistrationSuccess from "./components/MemberRegistration/RegistrationSuccess";
import OperatingCompany from "./components/Footer/OperatingCompany";
import ContactForm from "./components/Footer/ContactForm";
import GalleryFrontPage from "./components/Gallery/GalleryFrontPage/GalleryFrontPage";
import ViewGallery from "./components/Gallery/ViewGallery/ViewGallery";
import AuthContext, { AuthProvider } from "./context/AuthContext";
import React, { useContext } from "react";
import LogoutSuccess from "./components/Logout/LogoutSuccess";
import SharedGallery from "./components/Gallery/ViewGallery/SharedGallery";
import CartPage from "./components/Cart/CartPage";
import PurchaseSuccess from "./components/Purchase/PurchaseSuccess";
import NewsSingle from "./components/News/NewsSingle";
import TemporaryPasswordIssued from "./components/ForgotPassword/TemporaryPasswordIssued";
import FavoriteProduct from "./components/FavoriteProduct/FavoriteProduct";
import CheckHistory from "./components/CheckHistory/CheckHistory";
import UserSettings from "./components/UserSettings/UserSettings";
import Maintainance from "./components/EditScreen/Maintanence/Maintainance";
import ContactSuccess from "./components/ContactSubmit/ContactSuccess";
import VisitRegistrationSuccess from "./components/Top/VisitRegistrationSuccess";
import PointButtonPage from "./components/SimpleHelperPages/PointButtonPage";
import EditSuccess from "./components/Top/EditSuccess";
import GalleryAnnualStorage from "./components/Gallery/GalleryAnnualStorage/GalleryAnnualStorage";
import CartDetailsAnnual from "./components/Cart/CartDetailsAnnual";
import DesignBoxConfirmationPreviewPage from "./components/DesignBox/DesignBoxThirdFolderConfirmation/DesignBoxConfirmationPreviewPage";
import DesignBoxHopeToFix from "./components/DesignBox/DesignBoxThirdFolderConfirmation/DesignBoxHopeToFix";
import DesignBoxConfirmedMsg from "./components/DesignBox/DesignBoxThirdFolderConfirmation/DesignBoxConfirmedMsg";
import DesignBoxEditedPreview from "./components/DesignBox/DesignBoxTabForFolderFirstSecond/DesignEditedPreview/DesignBoxEditedPreview";
import GalleryDataRepurchase from "./components/Gallery/GalleryDataRepurchase/GalleryDataRepurchase";
import AnnualPassContractStatus from "./components/AnnualPassContractStatus/AnnualPassContractStatus";
import CartDataRepurchase from "./components/Gallery/GalleryDataRepurchase/CartDataRepurchase";
import CreateAlbumSuccess from "./components/Album/CreateAlbumSuccess";
import GallereShareSuccess from "./components/Gallery/ViewGallery/GallereShareSuccess";
import CompleteSubmission from "./components/Reusables/CompleteSubmissionComponent/CompleteSubmission";
import MountSide3sets from "./components/EditScreen/MountSide3sets/MountSide3sets";

function AllRoutes() {
  const c = useContext(AuthContext);

  const loggedIn = !!c.user;
  console.log(loggedIn);

  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <div>
            <Header />
            <Home />
            <Footer />
          </div>
        }
      ></Route>

      <Route
        path="/register"
        element={loggedIn ? <Navigate to="/" /> : <Register />}
      ></Route>
      <Route
        path="/onlineshop"
        element={<OnlineShop locked={!loggedIn} />}
      ></Route>
      <Route
        path="/login/shop"
        element={
          !loggedIn ? <Login onlineshopLogin={true} /> : <Navigate to="/" />
        }
      ></Route>
      <Route
        path="/top"
        element={!loggedIn ? <Login myPageLogin={true} /> : <Top />}
      ></Route>
      <Route
        path="/visit-reg-success"
        element={
          <div>
            <Header />
            <VisitRegistrationSuccess />
            <Footer />
          </div>
        }
      ></Route>
      <Route
        path="/point-photo-1"
        element={
          <div>
            <Header />
            <PointButtonPage />
            <Footer />
          </div>
        }
      ></Route>

      <Route
        path="/edit-success"
        element={
          <div>
            <Header />
            <EditSuccess />
            <Footer />
          </div>
        }
      ></Route>
      <Route
        path="/commercialtransactions"
        element={
          <div>
            <Header />
            <CommercialTransactions />
            <Footer />
          </div>
        }
      ></Route>
      <Route
        path="/gallery"
        element={!loggedIn ? <Navigate to="/login" /> : <Gallery />}
      ></Route>
      <Route path="/privacypolicy" element={<PrivacyPolicy />}></Route>
      <Route path="/features" element={<Features />}></Route>
      <Route
        path="/faq"
        element={
          <>
            <Header />
            <Faq />
          </>
        }
      ></Route>
      <Route exact path="/album/create" element={<CreateAlbum />}></Route>
      <Route
        exact
        path="/create-album-success"
        element={<CreateAlbumSuccess />}
      ></Route>
      <Route
        exact
        path="/visit-registration"
        element={<VisitRegistration />}
      ></Route>
      <Route exact path="/usage-flow" element={<UsageFlow />}></Route>

      <Route exact path="/design-box">
        <Route
          index
          element={!loggedIn ? <Login designBoxLogin={true} /> : <DesignBox />}
        />
        <Route path="edited-preview" element={<DesignBoxEditedPreview />} />
        <Route path=":id" element={<DesignBoxConfirmationPreviewPage />} />
        <Route path="hope-to-fix" element={<DesignBoxHopeToFix />} />
        <Route path="confirm-message" element={<DesignBoxConfirmedMsg />} />
      </Route>
      <Route path="/forgot-id" element={<ForgotID />}></Route>
      <Route path="/forgot-password" element={<ForgotPassword />}></Route>
      <Route path="/cart-item" element={<CartItem />}></Route>
      <Route path="/cart-annual-pass" element={<CartDetailsAnnual />}></Route>
      <Route path="/cart-item/details" element={<CartDetails />}></Route>
      <Route path="/purchase-history" element={<PurchaseHistoryMain />}></Route>
      <Route
        path="/purchase-history/details"
        element={<PurchaseDetails />}
      ></Route>
      <Route
        exact
        path="/member-registration"
        element={<MemberRegistration />}
      ></Route>
      <Route
        path="/registration-data"
        element={<RegistrationDataShow />}
      ></Route>
      <Route path="/otp" element={<Otp />}></Route>

      {/* DESIGN PAGE ROUTES */}

      <Route path="/editscreen/TypeA20" element={<TypeA20 />}></Route>
      <Route
        path="/design-box/album101/:product_id"
        element={<TypeA20 />}
      ></Route>
      <Route
        path="/design-box/complete-submission"
        element={<CompleteSubmission />}
      ></Route>

      <Route
        path="/editscreen/WoodenPlateSquare"
        element={<WoodenPlateSquare />}
      ></Route>
      <Route
        path="/design-box/wooden_plate_square/:product_id"
        element={<WoodenPlateSquare />}
      ></Route>

      <Route
        path="/editscreen/WoodenPlateRectangle"
        element={<WoodenPlateRectangle />}
      ></Route>
      <Route
        path="/design-box/wooden_plate_rectangle/:product_id"
        element={<WoodenPlateRectangle />}
      ></Route>
      <Route path="/editscreen/CalenderWall" element={<CalenderWall />}></Route>
      <Route
        path="/design-box/calender/:product_id"
        element={<CalenderWall />}
      ></Route>
      <Route
        path="/editscreen/WoodenDesignPlate"
        element={<WoodenDesignPlate />}
      ></Route>
      <Route
        path="/design-box/wooden_design_plate/:product_id"
        element={<WoodenDesignPlate />}
      ></Route>
      <Route path="/editscreen/PrintL" element={<PrintL />}></Route>
      <Route path="/editscreen/Print2L" element={<Print2L />}></Route>

      <Route path="/design-box/printL/:product_id" element={<PrintL />}></Route>
      <Route
        path="/design-box/print2L/:product_id"
        element={<Print2L />}
      ></Route>
      {/* Mount category */}
      <Route path="/editscreen/MountSide3P1" element={<MountSide3P1 />}></Route>
      <Route
        path="/design-box/3side1cut/:product_id"
        element={<MountSide3P1 />}
      ></Route>
      <Route path="/editscreen/MountSide2C2" element={<MountSide2C2 />}></Route>
      <Route
        path="/design-box/2side2cut/:product_id"
        element={<MountSide2C2 />}
      ></Route>
      <Route path="/editscreen/MountSide2C1" element={<MountSide2C1 />}></Route>
      <Route
        path="/design-box/2side1cut/:product_id"
        element={<MountSide2C1 />}
      ></Route>
      <Route
        path="/design-box/3side3cut/:product_id"
        element={<MountSide3sets />}
      ></Route>

      <Route
        path="/editscreen/KeyringSquare"
        element={<KeyringSquare />}
      ></Route>
      <Route
        path="/design-box/keyringsquare/:product_id"
        element={<KeyringSquare />}
      ></Route>

      <Route
        path="/editscreen/KeyringRectangle"
        element={<KeyringRectangle />}
      ></Route>
      <Route
        path="/design-box/keyringrectangle/:product_id"
        element={<KeyringRectangle />}
      ></Route>
      <Route
        path="/editscreen/PrintQuarterSize"
        element={<PrintQuarterSize />}
      ></Route>
      <Route
        path="/design-box/printquartersize/:product_id"
        element={<PrintQuarterSize />}
      ></Route>

      <Route path="/editscreen/Postcard" element={<Postcard />}></Route>
      <Route
        path="/design-box/postcard/:product_id"
        element={<Postcard />}
      ></Route>

      <Route path="/editscreen/NewYearCard" element={<NewYearCard />}></Route>
      <Route
        path="/design-box/newyearscard/:product_id"
        element={<NewYearCard />}
      ></Route>
      <Route
        path="/editscreen/PassportPartPhoto"
        element={<PassportPartPhoto />}
      ></Route>
      <Route
        path="/design-box/passportpartphoto/:product_id"
        element={<PassportPartPhoto />}
      ></Route>
      <Route
        path="/login"
        element={loggedIn ? <Navigate to="/" /> : <Login />}
      ></Route>
      <Route
        path="/registration-success"
        element={<RegistrationSuccess />}
      ></Route>
      <Route path="/operating-company" element={<OperatingCompany />}></Route>
      <Route path="/contact-form" element={<ContactForm />}></Route>
      <Route
        path="/gallery-front"
        element={
          !loggedIn ? <Login galleryLogin={true} /> : <GalleryFrontPage />
        }
      ></Route>
      <Route
        path="/gallery-annual-storage"
        element={
          !loggedIn ? <Login galleryLogin={true} /> : <GalleryAnnualStorage />
        }
      ></Route>
      <Route
        path="/gallery-data-repuchase"
        element={
          !loggedIn ? <Login galleryLogin={true} /> : <GalleryDataRepurchase />
        }
      ></Route>
      <Route
        path="/cart-data-repurchase"
        element={
          !loggedIn ? <Login cartLogin={true} /> : <CartDataRepurchase />
        }
      ></Route>
      <Route
        path="/cart-front"
        element={!loggedIn ? <Login cartLogin={true} /> : <CartPage />}
      ></Route>
      <Route
        path="/cart-front"
        element={!loggedIn ? <Login cartLogin={true} /> : <CartPage />}
      ></Route>
      <Route
        path="/gallery-view"
        element={!loggedIn ? <Login galleryLogin={true} /> : <ViewGallery />}
      ></Route>
      <Route
        path="/gallery-share-success"
        element={<GallereShareSuccess />}
      ></Route>
      <Route path="/logout-success" element={<LogoutSuccess />}></Route>
      <Route path="/contact-success" element={<ContactSuccess />}></Route>
      <Route path="/inquiry" element={<Inquiry />}></Route>
      <Route path="/shop/album/shared/:id" element={<SharedGallery />}></Route>
      <Route path={"/cart"} element={<CartPage />}></Route>
      <Route path={"/purchase-success"} element={<PurchaseSuccess />}></Route>
      <Route path={"/news-single/:news_id"} element={<NewsSingle />}></Route>
      <Route
        path={"/forgotpassword-success"}
        element={<TemporaryPasswordIssued />}
      ></Route>
      <Route path={"/favorite-product"} element={<FavoriteProduct />}></Route>
      <Route path={"/check-history"} element={<CheckHistory />}></Route>
      <Route
        path={"/check-history/2"}
        element={<CheckHistory tab={2} />}
      ></Route>

      <Route path={"/user-settings"} element={<UserSettings />}></Route>
      <Route
        path={"/design-box/maintainance"}
        element={<Maintainance />}
      ></Route>
      <Route
        path="/annual-pass-contract-status"
        element={<AnnualPassContractStatus />}
      ></Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <AllRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;
